// // src/redux/slices/loan/loanReportSlice.js
// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axios from 'axios';

// const API_URL = process.env.REACT_APP_API_URL;



// export const fetchAllLoans = createAsyncThunk(
//   'loanReport/fetchAllLoans',
//   async (_, { rejectWithValue }) => {
//     try {
//       const userId = localStorage.getItem('userId');

//       if (!userId) {
//         return rejectWithValue('UserId not found in localStorage');
//       }

//       const response = await axios.get(`${API_URL}/get-all-loan?userId=${userId}`);
//       const data = response.data;

//       if (Array.isArray(data)) {
//         return data;
//       } else if (Array.isArray(data.loans)) {
//         return data.loans;
//       } else if (Array.isArray(data.data)) {
//         return data.data;
//       } else {
//         return rejectWithValue('Unexpected response format from server.');
//       }

//     } catch (error) {
//       const message =
//         typeof error.response?.data === 'string'
//           ? error.response.data
//           : error.response?.data?.message || error.message || 'Failed to fetch loans';
//       return rejectWithValue(message);
//     }
//   }
// );



// // Slice
// const loanReportSlice = createSlice({
//   name: 'loanReport',
//   initialState: {
//     loans: [],
//     loading: false,
//     error: null,
//   },
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchAllLoans.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchAllLoans.fulfilled, (state, action) => {
//         state.loading = false;
//         state.loans = action.payload || [];
//       })
//       .addCase(fetchAllLoans.rejected, (state, action) => {
//         state.loading = false;
//         state.error = typeof action.payload === 'string'
//           ? action.payload
//           : 'Failed to fetch loan data';
//       });
//   },
// });

// export default loanReportSlice.reducer;

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';

const API_URL = process.env.REACT_APP_API_URL;

// ==========================
// Fetch All Loans
// ==========================
export const fetchAllLoans = createAsyncThunk(
  'loanReport/fetchAllLoans',
  async (_, { rejectWithValue }) => {
    try {
      const userId = localStorage.getItem('userId');
      if (!userId) {
        return rejectWithValue('UserId not found in localStorage');
      }

      const response = await axios.get(`${API_URL}/get-all-loan-sgd?userId=${userId}`);
      const data = response.data;
      console.log(data)

      if (Array.isArray(data)) return data;
      if (Array.isArray(data.loans)) return data.loans;
      if (Array.isArray(data.data)) return data.data;

      return rejectWithValue('Unexpected response format from server.');
    } catch (error) {
      const message =
        typeof error.response?.data === 'string'
          ? error.response.data
          : error.response?.data?.message || error.message || 'Failed to fetch loans';
      return rejectWithValue(message);
    }
  }
);

// ==========================
// Delete Loan
// ==========================
export const deleteLoan = createAsyncThunk(
  'loanReport/deleteLoan',
  async (loanId, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${API_URL}/delete-loan/${loanId}`);
      toast.success(response.data?.message || 'Loan deleted successfully')
      return { id: loanId, message: response.data?.message || 'Loan deleted successfully' };
    } catch (error) {
      const message =
        typeof error.response?.data === 'string'
          ? error.response.data
          : error.response?.data?.message || error.message || 'Failed to delete loan';
      return rejectWithValue(message);
    }
  }
);

// ==========================
// Slice
// ==========================
const loanReportSlice = createSlice({
  name: 'loanReport',
  initialState: {
    loans: [],
    loading: false,
    error: null,
    deleteSuccess: false,
  },
  reducers: {
    clearDeleteStatus: (state) => {
      state.deleteSuccess = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ===== Fetch All Loans =====
      .addCase(fetchAllLoans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllLoans.fulfilled, (state, action) => {
        state.loading = false;
        state.loans = action.payload || [];
      })
      .addCase(fetchAllLoans.rejected, (state, action) => {
        state.loading = false;
        state.error =
          typeof action.payload === 'string'
            ? action.payload
            : 'Failed to fetch loan data';
      })

      // ===== Delete Loan =====
      .addCase(deleteLoan.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.deleteSuccess = false;
      })
      .addCase(deleteLoan.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteSuccess = true;
        state.loans = state.loans.filter((loan) => loan.id !== action.payload.id);
      })
      .addCase(deleteLoan.rejected, (state, action) => {
        state.loading = false;
        state.deleteSuccess = false;
        state.error =
          typeof action.payload === 'string'
            ? action.payload
            : 'Failed to delete loan';
      });
  },
});

export const { clearDeleteStatus } = loanReportSlice.actions;
export default loanReportSlice.reducer;

